import { ReactNode } from 'react'
import { cn } from 'src/utils/style'

interface EmptyStateProps {
  title: ReactNode
  description?: ReactNode
  /** Optional call to action (e.g. a `Button`). */
  action?: ReactNode
  /** Optional `<AssistantHint />` shown under the copy. */
  assistantHint?: ReactNode
  className?: string
  'data-testid'?: string
}

/** Shared empty state: title, optional description/action, optional assistant hint. */
export const EmptyState = ({
  title,
  description,
  action,
  assistantHint,
  className,
  'data-testid': testId,
}: EmptyStateProps) => (
  <div
    className={cn(['flex flex-col items-center gap-2 py-4 text-center', className])}
    data-testid={testId}
  >
    <p className="text-sm text-text-tertiary">{title}</p>
    {description && <p className="text-sm text-text-tertiary">{description}</p>}
    {action}
    {assistantHint && <div className="mt-2 w-full max-w-md text-left">{assistantHint}</div>}
  </div>
)
